import { SessionStatus, SessionType } from "@/autoGeneratedGlobalTypes";
import { isSessionIdValid } from "@/utils/commonUtils";

import type { getActiveSession } from "../graphql/__generated__/getActiveSession";

/**
 * Проверяет валидность данных сессии
 */
export const isSessionDataValid = (
  data: getActiveSession | undefined | null,
): boolean => {
  if (!data?.getActiveSession) {
    return false;
  }

  return isSessionIdValid(data.getActiveSession.id);
};

/**
 * Проверяет, является ли сессия ожидающей видео звонок
 */
export const isWaitingVideoSession = (
  status?: SessionStatus | null,
  sessionType?: SessionType | null,
): boolean =>
  status === SessionStatus.waiting && sessionType === SessionType.VIDEO_CALL;
